import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/HelloWorld'
import Home from '@/components/content/Home'
import About from '@/components/content/About'
import Plan from '@/components/content/Plan'
import News from '@/components/content/News'
import Invest from '@/components/content/Invest'
import Recruit from '@/components/content/Recruit'

Vue.use(Router)


//添加以下代码
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/",
      component: Hello,
      children: [
        
        {
          path: '/home',
          component: Home
        },
        {
          path: '/about',
          component: About
        },
        {
          path: '/plan',
          component: Plan
        },
        {
          path: '/news',
          component: News
        },
        {
          path: '/invest',
          component: Invest
        },
        {
          path: '/recruit',
          component: Recruit
        }

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js